import i18n from '@/api/i18n/i18n';

export const COLUMNS_CONSOLIDATED = [
  { name: i18n.t('reports.columns.user'), sort: 2, field: 'name' },
  { name: i18n.t('reports.columns.enabled'), sort: 0, field: 'workTime' },
  { name: i18n.t('reports.columns.activity'), sort: 0, field: 'activeTime' },
  { name: i18n.t('reports.columns.idle'), sort: 0, field: 'idleTime' },
  { name: i18n.t('reports.columns.activePercent'), sort: 0, field: 'activePercent' },
  { name: i18n.t('reports.columns.planned'), sort: 0, field: 'workPlan' },
  { name: i18n.t('reports.columns.overwork'), sort: 0, field: 'overwork' },
  { name: i18n.t('reports.columns.absent'), sort: 0, field: 'outOfWork' },
  { name: i18n.t('reports.columns.onWeekends'), sort: 0, field: 'holidayWork' },
  { name: i18n.t('reports.columns.outsidePC'), sort: 0, field: 'meetings' },
  { name: i18n.t('reports.columns.productiveTime'), sort: 0, field: 'productive' },
  { name: i18n.t('reports.columns.unproductiveTime'), sort: 0, field: 'notProductive' },
  { name: i18n.t('reports.columns.neutralTime'), sort: 0, field: 'neutral' },
  { name: i18n.t('reports.columns.printer'), sort: 0, field: 'printer' },
];

export const COLUMNS_SUMMARY = [
  { name: i18n.t('reports.columns.employee'), width: 30, sort: 2, field: 'name' },
  { name: i18n.t('reports.columns.securityStatus'), sort: 0, field: 'securityStatus' },
  { name: i18n.t('reports.columns.productivityStatus'), sort: 0, field: 'productivityStatus' },
  { name: i18n.t('reports.columns.triggers'), sort: 0, field: 'triggers' },
  { name: i18n.t('reports.columns.absent'), sort: 0, field: 'outOfWork' },
  { name: i18n.t('reports.columns.late'), sort: 0, field: 'late' },
  { name: i18n.t('reports.columns.averageWorkingDayLength'), sort: 0, field: 'aveWorking' },
  { name: i18n.t('reports.columns.productiveTime'), sort: 0, field: 'productive' },
  { name: i18n.t('reports.columns.unproductiveTime'), sort: 0, field: 'notProductive' },
];

export const COLUMNS_LATE = [
  { name: i18n.t('reports.columns.employee'), sorted: true, field: 'name' },
  { name: i18n.t('reports.columns.quantity'), sorted: true, field: 'quantity' },
  { name: i18n.t('reports.columns.total'), sorted: true, field: 'total' },
  { name: i18n.t('reports.columns.dates'), field: 'dates' },
];

export const COLUMNS_OUT = [
  { name: i18n.t('reports.columns.employee'), sorted: true, field: 'name' },
  { name: i18n.t('reports.columns.quantity'), sorted: true, field: 'outOfWork' },
  { name: i18n.t('reports.columns.dates'), field: 'datesOut' },
];

export const COLUMNS_TRIGGERS = [
  { name: i18n.t('reports.columns.employee'), width: 30, sorted: true, field: 'name' },
  { name: i18n.t('reports.columns.triggers'), width: 30, sorted: true, field: 'triggers' },
  { name: '', sort: 0, field: 'reasonString' },
];

export const COLUMNS_TRIGGERS_USER = [
  { name: i18n.t('reports.columns.category'), width: 30, sorted: true, field: 'category' },
  { name: i18n.t('reports.columns.triggers'), width: 30, sorted: true, field: 'triggers' },
  { name: '', sort: 0, field: 'reasonString' },
];
export const COLUMNS_STATUS = [
  { name: i18n.t('reports.columns.security'), field: 'securityStatus' },
  { name: i18n.t('reports.columns.productivity'), field: 'productivityStatus' },
];

export const COLUMNS_ACTIVITY_PRODUCTIVITY = [
  { name: i18n.t('reports.columns.metric') },
  { name: i18n.t('reports.columns.value') },
];

export const COLUMNS_PROGRAM = [
  { name: i18n.t('reports.columns.program'), width: 30, field: 'name' },
  { name: i18n.t('reports.columns.activityTime'), width: 25, sorted: true, field: 'duration' },
  { name: i18n.t('reports.columns.productivity'), width: 25, field: 'productivity' },
  { name: i18n.t('reports.columns.category'), field: 'categoryName' },
];

export const COLUMNS_WEBSITES = [
  { name: i18n.t('reports.columns.website'), width: 30, field: 'link' },
  { name: i18n.t('reports.columns.activityTime'), width: 25, sorted: true, field: 'duration' },
  { name: i18n.t('reports.columns.productivity'), width: 25, field: 'productivity' },
  { name: i18n.t('reports.columns.category'), field: 'categoryName' },
];

export const COLUMNS_SECURETY = [
  { name: i18n.t('reports.columns.triggers') },
  { name: i18n.t('reports.columns.numberOfEarnings') },
];

export const COLUMNS_RISK = [{ name: i18n.t('reports.columns.risk') }, { name: i18n.t('reports.columns.note') }];

export const CLICKABLE_KEYS_MAP = {
  lateCount: 'summaryLateEarly',
  absencesCount: 'summaryAbsent',
};

export const CLICKABLE_KEYS = Object.keys(CLICKABLE_KEYS_MAP);
